import React from "react"

export default function Leave() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <g clipPath="url(#clip0_8_269)">
        <path d="M20.6886 12.6318L14.7725 18.538C14.2442 19.0654 13.3287 18.6962 13.3287 17.9404V14.5654H8.53937C8.07101 14.5654 7.6942 14.1892 7.6942 13.7216V10.3466C7.6942 9.87906 8.07101 9.50288 8.53937 9.50288H13.3287V6.12788C13.3287 5.37554 14.2407 5.00288 14.7725 5.53023L20.6886 11.4365C21.0161 11.7669 21.0161 12.3013 20.6886 12.6318ZM9.94798 18.3623V16.956C9.94798 16.724 9.75782 16.5341 9.5254 16.5341H6.56731C5.944 16.5341 5.44042 16.0314 5.44042 15.4091V8.65913C5.44042 8.03687 5.944 7.53413 6.56731 7.53413H9.5254C9.75782 7.53413 9.94798 7.34429 9.94798 7.11226V5.70601C9.94798 5.47398 9.75782 5.28413 9.5254 5.28413H6.56731C4.7009 5.28413 3.18665 6.79585 3.18665 8.65913V15.4091C3.18665 17.2724 4.7009 18.7841 6.56731 18.7841H9.5254C9.75782 18.7841 9.94798 18.5943 9.94798 18.3623Z" fill="#653fd5" />
      </g>
      <defs>
        <clipPath id="clip0_8_269">
          <rect width="18.027" height="18" fill="white" transform="translate(3.18353 3.03418)" />
        </clipPath>
      </defs>
    </svg>
  )
}